import React from "react";
import Input from "../../../../Components/Common/Input";
import ImageSelector from "../../../../Components/Common/ImageSelector";

const SubTopicForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
}) => {
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter sub topic title"
          error={errors.title}
          required
        />

        <ImageSelector
          label="Upload Files"
          name="link"
          setModalOpen={setModalOpen}
          onChange={onChange}
          value={formData.link}
          placeholder="Click to select a file"
          multiple
        />
      </form>
    </>
  );
};

export default SubTopicForm;
